import ChartOfAccount from "./ChartOfAccount";

export default ChartOfAccount;